import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export interface IPaymentsBasketView {
    icon: string;
    name: string;
}

@Component({
    selector: 'basket-view-paywith',
    templateUrl: './basket-view-paywith.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BasketViewPaywithComponent {
    @Input()
    payments: IPaymentsBasketView[] = [];
}
